import { createSignal } from '@verclam/pulsar';

/** `null` when no deletion is pending confirmation; otherwise the id of the limit to confirm. */
const aiCostLimitToDeleteSignal = createSignal<number | null>(null);

export const setAiCostLimitToDelete = (limitId: number | null): void => {
	aiCostLimitToDeleteSignal.value = limitId;
};

export default aiCostLimitToDeleteSignal;
